<template>
  <v-container class="home-main" id="home-container">
    <div class="boxes">
      <div class="maintitle">{{ $t("Home.DivisionTitle") }}</div>
      <v-row class="row-boxes">
        <v-col cols="6" xs="6" class="lg2-custom" v-for="(d, index) in divisions" :key="index"
          @click="navigateTo('division', index + 1)" v-if="index == 0 || index == 3">
          <division :item="d" :division="index + 1"> </division>
        </v-col>
      </v-row>
    </div>

    <div class="boxes second-row">
      <v-row class="row-boxes">
        <v-col cols="6" sm="4" class="second-row-col" v-for="(s, index) in supports" :key="index">
          <imagebox :item="s"> </imagebox>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<style>
.home-main .single-box {
  position: relative;
}

.home-main .division {
  cursor: pointer;
}

@media (min-width: 600px) {

  .home-main .boxes,
  .communications-main,
  .communications-admin,
  .quotations-main .boxes {
    height: auto;
    margin: 0px 46px 0 46px !important;
  }

  #load-communication-container,
  #communications-container,
  #home-container,
  #support-container,
  #profile-container,
  #quotations-container {
    padding: 140px 0 50px 0;
  }

  .home-main .lg5-custom,
  .profile-main .lg5-custom,
  .quotations-main .lg5-custom {
    width: 20%;
    max-width: 20%;
    flex-basis: 20%;
    position: relative;
  }

  .home-main .lg2-custom,
  .profile-main .lg2-custom,
  .quotations-main .lg2-custom {
    width: 50%;
    max-width: 50%;
    flex-basis: 50%;
    position: relative;
  }
}

@media (max-width: 600px) {
  .home-main .boxes .maintitle {
    font: normal normal bold 20px/24px Roboto;
  }

  .quotations-main .boxes .title {
    line-height: 24px;
  }

  .home-main .boxes,
  .quotations-main .boxes {
    height: auto;
    margin: 0 12px 0 12px;
  }

  #home-container,
  #quotations-container {
    padding: 126px 0 40px 0;
  }

  .home-main .container,
  .profile-main .container {
    max-width: calc(100% - 40px) !important;
  }

  .second-row-col {
    padding: 8px 12px 8px 12px;
  }

  .boxes.second-row {
    padding-top: 20px;
  }
}

.communication-component.communication-detail .buttons-div {
  margin-top: 43px;
  text-align: right;
}
</style>
<script>
import loading from "../components/loadingComponent.vue";
import grid from "../components/gridComponent.vue";
import division from "../components/division.vue";
import imagebox from "../components/imagebox.vue";
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
import GAApi from "../api/GA/GAApi.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import Communication from "../components/communication.vue";

export default {
  components: {
    grid,
    loading,
    division,
    imagebox,
    Communication,
  },

  data() {
    return {
      divisions: null,
      supports: null,
      isMobile: false,
    };
  },

  computed: {},

  watch: {},

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();

    this.divisions = this.$genericClass.getProfileDivisions();

    this.supports = [
      {
        title: Trans.i18n.t("Home.Quotations.title"),
        img_name: this.isMobile ? "quotazioni_mobile" : "quotations",
        btn_label: Trans.i18n.t("Home.Quotations.btn_label"),
        description: Trans.i18n.t("Home.Quotations.description"),
        url: "Quotations",
      },
      {
        title: Trans.i18n.t("Home.Communications.title"),
        img_name: this.isMobile ? "comunicazioni_mobile" : "communications",
        btn_label: Trans.i18n.t("Home.Communications.btn_label"),
        description: Trans.i18n.t("Home.Communications.description"),
        url: "Communications",
      },
      {
        title: Trans.i18n.t("Home.News.title"),
        img_name: this.isMobile ? "news_mobile" : "news",
        btn_label: Trans.i18n.t("Home.News.btn_label"),
        description: Trans.i18n.t("Home.News.description"),
        url: "News",
        showLink: true,
      },
    ];
  },

  methods: {
    async navigateTo(component, divisionId) {
      let userId = this.$GAUserAuth.user.id;
      let res = await GAApi.GetApplications(userId, divisionId)
      this.applications = res.data;

      if (this.applications.length == 0) {
        router.push({
          name: "quotations",
          params: { DivisionId: divisionId },
        });
        return;
      } else {
        router
          .push({ name: component, params: { DivisionId: divisionId } })
          .catch((err) => {
            this.close();
          });
      }
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>
